import seoRoutes from '@/seo/routes.json'

const routePaths = new Map(seoRoutes.map(route => [route.name, route.path]))

export const TOOL_CATEGORIES = [
  { id: 'all', en: 'All tools', ar: 'كل الأدوات' },
  { id: 'image-editing', en: 'Image Editing', ar: 'تعديل الصور' },
  { id: 'image-optimization', en: 'Image Optimization', ar: 'تحسين الصور' },
  { id: 'image-creation', en: 'Image Creation', ar: 'إنشاء الصور' },
  { id: 'privacy-effects', en: 'Image Privacy / Effects', ar: 'خصوصية وتأثيرات الصور' },
  { id: 'qr-barcode', en: 'QR & Barcode', ar: 'QR والباركود' },
  { id: 'seo', en: 'SEO Tools', ar: 'أدوات تحسين محركات البحث' },
  { id: 'business', en: 'Business', ar: 'أعمال' },
]

export const tools = [
  {
    id: 'background-remover', category: 'privacy-effects', popular: true,
    routeNameEn: 'background-removal-en', routeNameAr: 'background-removal-ar',
    titleEn: 'Background Remover', titleAr: 'إزالة خلفية الصورة',
    descriptionEn: 'Remove an image background automatically in your browser.',
    descriptionAr: 'أزل خلفية الصورة تلقائياً داخل متصفحك.'
  },
  {
    id: 'image-compressor', category: 'image-optimization', popular: true,
    routeNameEn: 'image-compress-en', routeNameAr: 'image-compress-ar',
    titleEn: 'Image Compressor', titleAr: 'ضغط الصور',
    descriptionEn: 'Reduce image file size while controlling output quality.',
    descriptionAr: 'قلّل حجم ملف الصورة مع التحكم في جودة النتيجة.'
  },
  {
    id: 'flip-image', category: 'image-editing', newTool: true,
    routeNameEn: 'flip-image-en', routeNameAr: 'flip-image-ar',
    titleEn: 'Flip Image', titleAr: 'قلب الصورة',
    descriptionEn: 'Flip a photo horizontally or vertically and download it instantly.',
    descriptionAr: 'اقلب الصورة أفقياً أو رأسياً ونزّل النتيجة فوراً.'
  },
  {
    id: 'rotate-image', category: 'image-editing', newTool: true,
    routeNameEn: 'rotate-image-en', routeNameAr: 'rotate-image-ar',
    titleEn: 'Rotate Image', titleAr: 'تدوير الصورة',
    descriptionEn: 'Rotate an image left, right or 180 degrees without uploading it.',
    descriptionAr: 'دوّر الصورة يميناً أو يساراً أو 180 درجة دون رفعها إلى خادم.'
  },
  {
    id: 'black-white-image', category: 'privacy-effects', newTool: true,
    routeNameEn: 'black-white-image-en', routeNameAr: 'black-white-image-ar',
    titleEn: 'Black & White Image', titleAr: 'تحويل الصورة إلى أبيض وأسود',
    descriptionEn: 'Turn a color photo into a clean black-and-white image.',
    descriptionAr: 'حوّل الصورة الملونة إلى صورة واضحة بالأبيض والأسود.'
  },
  {
    id: 'pixelate-image', category: 'privacy-effects', newTool: true,
    routeNameEn: 'pixelate-image-en', routeNameAr: 'pixelate-image-ar',
    titleEn: 'Pixelate Image', titleAr: 'بكسلة الصورة',
    descriptionEn: 'Add a pixelated effect and control the block size.', descriptionAr: 'أضف تأثير البكسلة وتحكم في حجم المربعات.'
  },
  {
    id: 'round-image', category: 'image-editing', newTool: true,
    routeNameEn: 'round-image-en', routeNameAr: 'round-image-ar',
    titleEn: 'Make Round Image', titleAr: 'قص الصورة بشكل دائري',
    descriptionEn: 'Create a centered circular image with a transparent background.', descriptionAr: 'قص الصورة بشكل دائري في المنتصف مع خلفية شفافة.'
  },
  {
    id: 'border-image', category: 'image-editing', newTool: true,
    routeNameEn: 'border-image-en', routeNameAr: 'border-image-ar',
    titleEn: 'Add Border to Image', titleAr: 'إضافة إطار للصور',
    descriptionEn: 'Add a custom color border and control its thickness.', descriptionAr: 'أضف إطارًا ملونًا للصور وتحكم في سُمكه.'
  },
  {
    id: 'text-image', category: 'image-editing', newTool: true,
    routeNameEn: 'text-image-en', routeNameAr: 'text-image-ar',
    titleEn: 'Add Text to Image', titleAr: 'الكتابة على الصور',
    descriptionEn: 'Write text over a photo and customize its style and position.', descriptionAr: 'اكتب على الصور وحدد لون النص وحجمه وموضعه.'
  },
  {
    id: 'crop-image', category: 'image-editing', newTool: true,
    routeNameEn: 'crop-image-en', routeNameAr: 'crop-image-ar',
    titleEn: 'Crop Image', titleAr: 'قص الصور',
    descriptionEn: 'Crop a precise area or create a centered square image.', descriptionAr: 'قص جزءاً محدداً أو أنشئ صورة مربعة في المنتصف.'
  },
  {
    id: 'color-picker', category: 'image-editing',
    routeNameEn: 'color-picker-en', routeNameAr: 'color-picker-ar',
    titleEn: 'Image Color Picker', titleAr: 'استخراج لون من صورة',
    descriptionEn: 'Pick a pixel and copy its HEX and RGB color values.',
    descriptionAr: 'حدد نقطة في الصورة وانسخ قيمة اللون.'
  },
  {
    id: 'watermark-image', category: 'image-editing', newTool: true,
    routeNameEn: 'watermark-image-en', routeNameAr: 'watermark-image-ar',
    titleEn: 'Add Watermark', titleAr: 'إضافة علامة مائية على الصور',
    descriptionEn: 'Place a logo or image watermark over a photo.', descriptionAr: 'ضع شعارًا أو علامة مائية على الصورة.'
  },
  {
    id: 'combine-images', category: 'image-creation', newTool: true,
    routeNameEn: 'combine-images-en', routeNameAr: 'combine-images-ar',
    titleEn: 'Combine Images', titleAr: 'دمج الصور',
    descriptionEn: 'Join multiple images horizontally or vertically.', descriptionAr: 'ادمج عدة صور أفقيًا أو رأسيًا.'
  },
  {
    id: 'image-splitter', category: 'image-editing', newTool: true,
    routeNameEn: 'image-splitter-en', routeNameAr: 'image-splitter-ar',
    titleEn: 'Image Splitter', titleAr: 'تقسيم الصور',
    descriptionEn: 'Split an image into equal rows and columns.', descriptionAr: 'قسّم الصورة إلى صفوف وأعمدة متساوية.'
  },
  {
    id: 'collage-maker', category: 'image-creation', newTool: true,
    routeNameEn: 'collage-maker-en', routeNameAr: 'collage-maker-ar',
    titleEn: 'Collage Maker', titleAr: 'تجميع الصور في صورة واحدة',
    descriptionEn: 'Arrange multiple photos using clean collage templates.', descriptionAr: 'جمّع وادمج عدة صور في صورة واحدة باستخدام قوالب كولاج جاهزة.'
  },
  {
    id: 'chart-maker', category: 'image-creation', newTool: true,
    routeNameEn: 'chart-maker-en', routeNameAr: 'chart-maker-ar',
    titleEn: 'Chart Maker', titleAr: 'إنشاء رسم بياني',
    descriptionEn: 'Create bar, line and pie charts and export them as images.', descriptionAr: 'أنشئ رسومًا عمودية وخطية ودائرية ونزّلها كصور.'
  },
  { id:'face-blur', category:'privacy-effects', newTool:true, routeNameEn:'face-blur-en', routeNameAr:'face-blur-ar', titleEn:'Face Blur', titleAr:'طمس الوجوه', descriptionEn:'Detect or select faces and blur them locally.', descriptionAr:'اكتشف الوجوه أو حددها واطمسها داخل متصفحك.' },
  { id:'background-blur', category:'privacy-effects', newTool:true, routeNameEn:'background-blur-en', routeNameAr:'background-blur-ar', titleEn:'Background Blur', titleAr:'تمويه خلفية الصورة', descriptionEn:'Keep the subject sharp and blur the photo background.', descriptionAr:'احتفظ بالعنصر واضحًا وموّه خلفية الصورة.' },
  { id:'colorize-photo', category:'privacy-effects', newTool:true, routeNameEn:'colorize-photo-en', routeNameAr:'colorize-photo-ar', titleEn:'Colorize Photo', titleAr:'تلوين الصور الأبيض والأسود', descriptionEn:'Apply customizable two-tone color to black-and-white photos.', descriptionAr:'أضف تلوينًا ثنائيًا قابلًا للتخصيص للصور الأبيض والأسود.' },
  { id:'text-tools', category:'image-creation', newTool:true, routeNameEn:'text-tools-en', routeNameAr:'text-tools-ar', titleEn:'Text Converter & Counter', titleAr:'عداد الكلمات والحروف', descriptionEn:'Change text case and count words, characters, sentences and reading time.', descriptionAr:'احسب الكلمات والحروف والجمل ووقت القراءة، وغيّر حالة النص.' },
  { id:'qr-generator', category:'qr-barcode', newTool:true, routeNameEn:'qr-generator-en', routeNameAr:'qr-generator-ar', titleEn:'QR Code Generator', titleAr:'مولد QR', descriptionEn:'Create customizable QR codes and download PNG or SVG files.', descriptionAr:'أنشئ QR Code مخصصاً ونزّله بصيغة PNG أو SVG.' },
  { id:'qr-scanner', category:'qr-barcode', newTool:true, routeNameEn:'qr-scanner-en', routeNameAr:'qr-scanner-ar', titleEn:'QR Code Scanner', titleAr:'قارئ QR', descriptionEn:'Read QR codes from an image or your device camera.', descriptionAr:'اقرأ QR من صورة أو باستخدام كاميرا جهازك.' },
  { id:'barcode-generator', category:'qr-barcode', newTool:true, routeNameEn:'barcode-generator-en', routeNameAr:'barcode-generator-ar', titleEn:'Barcode Generator', titleAr:'مولد باركود', descriptionEn:'Create Code 128, EAN, UPC, Code 39 and ITF barcodes.', descriptionAr:'أنشئ باركود Code 128 وEAN وUPC وCode 39 وITF.' },
  { id:'barcode-scanner', category:'qr-barcode', newTool:true, routeNameEn:'barcode-scanner-en', routeNameAr:'barcode-scanner-ar', titleEn:'Online Barcode Scanner', titleAr:'قارئ باركود', descriptionEn:'Scan popular barcode formats from a photo or camera.', descriptionAr:'اقرأ الباركود من صورة أو باستخدام الكاميرا.' },
  { id:'seo-meta-tool', category:'seo', newTool:true, routeNameEn:'seo-meta-tool-en', routeNameAr:'seo-meta-tool-ar', titleEn:'SEO Meta Tag Analyzer', titleAr:'فحص Meta Tags', descriptionEn:'Analyze, improve and preview title tags and meta descriptions.', descriptionAr:'افحص وحسّن وعاين عنوان الصفحة والوصف التعريفي.' },
  { id:'social-meta-tool', category:'seo', newTool:true, routeNameEn:'social-meta-tool-en', routeNameAr:'social-meta-tool-ar', titleEn:'Open Graph & Social Preview', titleAr:'معاينة Open Graph', descriptionEn:'Create, inspect and preview Open Graph and Twitter Card tags.', descriptionAr:'أنشئ وافحص وعاين وسوم Open Graph وTwitter Card.' },
  { id:'heading-checker', category:'seo', newTool:true, routeNameEn:'heading-checker-en', routeNameAr:'heading-checker-ar', titleEn:'Heading Structure Checker', titleAr:'فحص عناوين H1–H6', descriptionEn:'Audit H1–H6 hierarchy, skipped levels and keyword coverage.', descriptionAr:'افحص تسلسل H1–H6 والمستويات المتخطاة وتغطية الكلمات.' },
  { id:'image-metadata-tool', category:'image-optimization', additionalCategories:['privacy-effects'], newTool:true, routeNameEn:'image-metadata-tool-en', routeNameAr:'image-metadata-tool-ar', titleEn:'Image Metadata Tool', titleAr:'عرض وحذف بيانات EXIF', descriptionEn:'View, edit and remove image metadata locally, detect GPS and audit image SEO.', descriptionAr:'اعرض واحذف بيانات EXIF وGPS من الصور محلياً، وافحص SEO للصور.' },
  { id:'robots-tool', category:'seo', newTool:true, routeNameEn:'robots-tool-en', routeNameAr:'robots-tool-ar', titleEn:'Robots.txt Generator & Tester', titleAr:'مولد ملف robots.txt', descriptionEn:'Build robots rules, test URLs and detect dangerous crawl blocks.', descriptionAr:'أنشئ قواعد robots واختبر الروابط واكتشف أوامر منع الزحف الخطرة.' },
  { id:'sitemap-validator', category:'seo', newTool:true, routeNameEn:'sitemap-validator-en', routeNameAr:'sitemap-validator-ar', titleEn:'Sitemap Validator', titleAr:'فحص Sitemap XML', descriptionEn:'Validate XML, URLs, domains, duplicates and hreflang locally.', descriptionAr:'افحص XML والروابط والدومينات والتكرار وhreflang محليًا.' },
  { id:'canonical-hreflang', category:'seo', newTool:true, routeNameEn:'canonical-hreflang-en', routeNameAr:'canonical-hreflang-ar', titleEn:'Canonical & Hreflang Builder', titleAr:'مولد Canonical وHreflang', descriptionEn:'Generate canonical and alternate tags and check reciprocity.', descriptionAr:'أنشئ وسوم canonical والبدائل وافحص التبادل بينها.' },
  { id:'schema-generator', category:'seo', newTool:true, routeNameEn:'schema-generator-en', routeNameAr:'schema-generator-ar', titleEn:'Schema Markup Generator', titleAr:'مولد Schema Markup', descriptionEn:'Create validated JSON-LD for seven useful schema types.', descriptionAr:'أنشئ JSON-LD مدققًا لسبعة أنواع مفيدة من Schema.' },
  {
    id: 'image-editor', category: 'image-editing', popular: true,
    routeNameEn: 'image-editor-en', routeNameAr: 'image-editor-ar',
    titleEn: 'Image Editor', titleAr: 'محرر الصور',
    descriptionEn: 'Edit photos, add text and shapes, then export the result.',
    descriptionAr: 'عدّل الصور وأضف النصوص والأشكال ثم صدّر النتيجة.'
  },
  {
    id: 'format-converter', category: 'image-optimization',
    routeNameEn: 'format-converter-en', routeNameAr: 'format-converter-ar',
    titleEn: 'Image Format Converter', titleAr: 'محول صيغ الصور',
    descriptionEn: 'Convert images between popular formats in your browser.',
    descriptionAr: 'حوّل الصور بين الصيغ الشائعة داخل متصفحك.'
  },
  {
    id: 'gif-maker', category: 'image-creation',
    routeNameEn: 'gif-converter-en', routeNameAr: 'gif-converter-ar',
    titleEn: 'GIF Maker', titleAr: 'صانع GIF',
    descriptionEn: 'Create an animated GIF from a collection of images.',
    descriptionAr: 'أنشئ صورة GIF متحركة من مجموعة صور.'
  },
  {
    id: 'color-changer', category: 'image-editing',
    routeNameEn: 'color-changer-en', routeNameAr: 'color-changer-ar',
    titleEn: 'Image Color Changer', titleAr: 'تغيير لون الصورة',
    descriptionEn: 'Select and replace a color in an image.',
    descriptionAr: 'اختر لوناً في الصورة واستبدله بلون جديد.'
  },
  {
    id: 'wireframe', category: 'image-creation',
    hrefEn: '/Free_Wireframe_Design_Tool_from_SplendApp/',
    hrefAr: '/أداة_الرسم_Wireframing_المجانية_من_سبلينداب/',
    titleEn: 'Wireframe Tool', titleAr: 'أداة وايرفريم',
    descriptionEn: 'Sketch website and app layouts directly in your browser.',
    descriptionAr: 'ارسم مخططات المواقع والتطبيقات مباشرة داخل متصفحك.'
  },
  {
    id: 'booking-loss', category: 'business',
    routeNameEn: 'booking-loss-calculator-en', routeNameAr: 'booking-loss-calculator-ar',
    titleEn: 'Booking Loss Calculator', titleAr: 'حاسبة خسائر الحجوزات',
    descriptionEn: 'Estimate revenue lost to no-shows and cancellations.',
    descriptionAr: 'احسب الإيرادات المفقودة بسبب عدم الحضور والإلغاء.'
  },
  {
    id: 'app-roi-calculator', category: 'business', newTool: true,
    routeNameEn: 'app-roi-calculator-en', routeNameAr: 'app-roi-calculator-ar',
    titleEn: 'Mobile App Impact Calculator', titleAr: 'حاسبة تأثير تطبيق الجوال',
    descriptionEn: 'Estimate how a mobile app could affect store orders, sales, repeat purchases and marketing costs.',
    descriptionAr: 'احسب الأثر التقديري لتطبيق الجوال على طلبات متجرك ومبيعاته والتكرار الشرائي وتكلفة التسويق.'
  }
]

export function localizedTool(tool, language) {
  const isArabic = language === 'ar'
  const routeName = isArabic ? tool.routeNameAr : tool.routeNameEn
  return {
    ...tool,
    title: isArabic ? tool.titleAr : tool.titleEn,
    description: isArabic ? tool.descriptionAr : tool.descriptionEn,
    routeName,
    href: isArabic ? tool.hrefAr : tool.hrefEn
  }
}
